import backendHttpClient from '../../../http/axios/axios-http-client';
import { SoundtrackOptionsResponseDTO } from './dto/soundtrack-options-dto';

const PUBLIC_BOOKING_ENDPOINT = '/public/soundtracks';

export interface SoundtrackGateway {
  getSoundtrackOptions(): Promise<SoundtrackOptionsResponseDTO>;
}

export class SoundtrackGateway implements SoundtrackGateway {
  async getSoundtrackOptions(): Promise<SoundtrackOptionsResponseDTO> {
    const endpoint = `${PUBLIC_BOOKING_ENDPOINT}`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }
}
